import { Col } from "@/components/Theme/Col";

export function bulletListParser(node, children, parent, styles, colorScheme) {

  return (
      <Col mb={25} key={node.key} style={styles._VIEW_SAFE_bullet_list}>
        {children}
      </Col>
    )
}

export function orderedListParser(node, children, parent, styles, colorScheme) {
    return (
      <Col mb={25} key={node.key} style={styles._VIEW_SAFE_ordered_list}>
        {children}
      </Col>
    )
}